const queueStatus = Object.freeze({
  Pending: 1,
  Processing: 2,
  Completed: 3,
  Failed: 4,
});

export default queueStatus;
